import type { ReactNode } from 'react';
import { Collapse } from '@ksyos/design-system';

export function CustomControlCollapseBody(props: { children: ReactNode; isOpen: boolean }) {
    return <Collapse isOpen={props.isOpen}>{props.children}</Collapse>;
}
